import axios from 'axios';

// Accesso dell'app tenant: si rinnova da solo con il token di rinnovo (7 giorni, si allunga a ogni rinnovo)
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MARGINE_MS = 2 * 60 * 60 * 1000;
const NESSUN_RINNOVO = 'nessun-rinnovo';
let rinnovoInCorso = null;

const scadenzaMs = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp * 1000;
  } catch (e) {
    return 0;
  }
};

export const sessioneScaduta = () => window.dispatchEvent(new Event('sessione-scaduta'));

const rinnovoRifiutato = (e) => e?.message === NESSUN_RINNOVO || [401, 403].includes(e?.response?.status);

// Un solo rinnovo alla volta anche se più richieste ricevono 401 insieme
export const rinnovaSessione = () => {
  if (rinnovoInCorso) return rinnovoInCorso;
  const refresh = localStorage.getItem('tenant_refresh_token');
  if (!refresh) return Promise.reject(new Error(NESSUN_RINNOVO));
  rinnovoInCorso = axios.post(`${API}/saas/auth/refresh`, { refresh_token: refresh }, { _rinnovo: true })
    .then(({ data }) => {
      localStorage.setItem('tenant_token', data.access_token);
      localStorage.setItem('tenant_refresh_token', data.refresh_token);
      return data.access_token;
    })
    .finally(() => { rinnovoInCorso = null; });
  return rinnovoInCorso;
};

// All'apertura, al ritorno sull'app e ogni tanto: rinnova se l'accesso scade entro 2 ore
export const controllaSessione = async () => {
  const token = localStorage.getItem('tenant_token');
  if (!token || scadenzaMs(token) - Date.now() > MARGINE_MS) return;
  try {
    await rinnovaSessione();
  } catch (e) {
    if (rinnovoRifiutato(e) && scadenzaMs(token) <= Date.now()) sessioneScaduta();
  }
};

axios.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const dettaglio = String(error.response?.data?.detail || '');
    const daRinnovare = window.location.pathname.startsWith('/tenant') && error.response?.status === 401
      && cfg && !cfg._rinnovo && !cfg._ripetuta && !/login/.test(cfg.url || '')
      && /token|sessione|accesso richiesto/i.test(dettaglio);  // gli altri 401 non dipendono dall'accesso
    if (!daRinnovare) return Promise.reject(error);
    cfg._ripetuta = true;
    const usato = String(cfg.headers?.Authorization || '').replace('Bearer ', '');
    const attuale = localStorage.getItem('tenant_token');
    try {
      // già rinnovato da un'altra richiesta: basta riprovare con l'accesso nuovo
      const token = attuale && usato && attuale !== usato ? attuale : await rinnovaSessione();
      cfg.headers.Authorization = `Bearer ${token}`;
      return axios(cfg);
    } catch (e) {
      if (rinnovoRifiutato(e)) sessioneScaduta();
      return Promise.reject(error);
    }
  }
);
